import { render, staticRenderFns } from "./opinion.vue?vue&type=template&id=29ab18c7&scoped=true"
import script from "./opinion.vue?vue&type=script&lang=js"
export * from "./opinion.vue?vue&type=script&lang=js"
import style0 from "./opinion.vue?vue&type=style&index=0&id=29ab18c7&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ab18c7",
  null
  
)

export default component.exports